import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseAPIService } from '../base.api.service';

export interface ServiceShortcutItem {
    id: number;
    name: string;
    link: any;
    priority: number;
    created_at?: string;
    updated_at?: string;
    new_badge_start_at?: string | null;
    new_badge_end_at?: string | null;
    status?: string | null;
}

@Injectable()
export class HomeTabServiceShortcutsService extends BaseAPIService {

    private ROUTES = {
        list: '/home-tab/service-shortcuts',
        item: '/home-tab/service-shortcuts/:id',
        priorityBulk: '/home-tab/service-shortcuts/priority/bulk'
    };

    constructor(protected http: HttpClient) {
        super(http);
    }

    // 전체 목록 조회
    getList(): Promise<ServiceShortcutItem[]> {
        return this.GET<ServiceShortcutItem[]>(this.ROUTES.list).toPromise();
    }

    // 단일 아이템 조회
    getItem(id: number): Promise<ServiceShortcutItem> {
        return this.GET<ServiceShortcutItem>(this.ROUTES.item, { id }).toPromise();
    }

    // 아이템 생성
    createItem(data: Partial<ServiceShortcutItem>): Promise<ServiceShortcutItem> {
        return this.POST<ServiceShortcutItem>(this.ROUTES.list, null, data).toPromise();
    }

    // 아이템 내용 수정
    updateItem(id: number, data: Partial<ServiceShortcutItem>): Promise<any> {
        return this.PUT(this.ROUTES.item, { id }, data).toPromise();
    }

    // 아이템 삭제
    deleteItem(id: number): Promise<any> {
        return this.DELETE(this.ROUTES.item, { id }).toPromise();
    }

    // 우선순위 일괄 저장
    updatePriority(items: { id: number; priority: number; status?: string }[]): Promise<any> {
        return this.PUT(this.ROUTES.priorityBulk, null, { items }).toPromise();
    }
}
